import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FastCheckinParkingSessionInfoDTO, SessionEventType } from 'src/app/base/models/models.swagger.generated';
import { PriceUtils } from 'src/app/base/utils/price-utils';

@Component({
  selector: 'app-fast-checkin-session-closed',
  templateUrl: './fast-checkin-session-closed.component.html',
  styleUrls: ['./fast-checkin-session-closed.component.scss'],
  imports: [TranslateModule]
})
export class FastCheckinSessionClosedComponent implements OnInit {
  @Input() public sessionInfo: FastCheckinParkingSessionInfoDTO;
  @Output() public downloadReceipt: EventEmitter<void> = new EventEmitter<void>();

  public get sessionPriceWithCurrency(): string {
    if (this.sessionInfo) {
      return PriceUtils.getPriceWithCurrency(this.sessionInfo.totalWithVat, this.sessionInfo.currency);
    }
    return '';
  }

  public get closingAction(): string {
    if (this.sessionInfo.sessionClosingEventType) {
      if (this.sessionInfo.sessionClosingEventType === SessionEventType.Manually) {
        return 'i18n.domain.fast-checkin-session.close-action-manually';
      } else {
        return 'i18n.domain.fast-checkin-session.close-action-automatically';
      }
    }
    return '';
  }

  constructor() { }

  ngOnInit() {
  }

  public getClosedSessionDuration(): string {
    if (this.sessionInfo && this.sessionInfo.isClosed) {
      const endMinutes = Math.floor(this.sessionInfo.endDateTime.toMillis() / (1000 * 60));
      const startMinutes = Math.floor(this.sessionInfo.startDateTime.toMillis() / (1000 * 60));
      const totalMinutes = endMinutes - startMinutes;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}m`;
    }
    return '';
  }

  public onDownloadReceipt(): void {
    this.downloadReceipt.emit();
  }
}
